import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useGetRaceTypesQuery } from '../../../../services/RegistrationService';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { updateRegistration } from '../../../../services/RegistrationService/registrationSlice/';

const RaceEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const demographics = useAppSelector(state => state.registration.currentRegistration?.demographics) || {};
  const value = demographics.race || '';
  const { data: raceTypes = [], isLoading } = useGetRaceTypesQuery();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateRegistration({
      demographics: {
        ...demographics,
        race: e.target.value,
      },
    }));
  };

  return (
    <TextField
      select
      value={value}
      onChange={handleChange}
      size="small"
      label="Race"
      disabled={isLoading}
      sx={{ width: 205 }}
    >
      <MenuItem value="">
        Select Race
      </MenuItem>
      {raceTypes.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default RaceEdit;
